import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";

export class ProbationaryPeriodSummaryModel extends Model implements IModel<ProbationaryPeriodSummaryModel>
{
  public inProbationary: number = 0;
  public awaitingEvaluation: number = 0;
  public retainedContracts: number = 0;
  public terminatedContracts: number = 0;
  
  static create(input: any): ProbationaryPeriodSummaryModel {
    return ObjectMapper.deserialize<ProbationaryPeriodSummaryModel>(ProbationaryPeriodSummaryModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
